<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            :main_icon="main_icon"
            :icons="icon_data"
            :load_url="load_url"
            :title="title">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'TodaysAppraisalStatusFromKitReceived',
        components: {DashboardCard},
        props: {
            width: {type:Number, default: 25},
            dataDisplay: {type:String, default: null},
        },
        data() {
            return {
                main_icon: 'fa-light fa-box-full',
                title: 'Today\'s Appraisal',
                load_url: '/dashboards/TodayAppraisal/',
                icon_data: [
                    {
                        name: 'Previous Day(s) Outstanding',
                        text_color: '#FF6666',
                    },
                    {
                        name: 'Today\'s Orders To Process',
                        text_color: '#2A9D8F',
                    },
                    {
                        name: 'Previous Day\'s Orders Processed',
                        text_color: '#264653',
                    },
                    {
                        name: 'Todays\'s Orders Processed',
                        text_color: '#264653',
                    },
                    {
                        name: 'Total Orders Processed',
                        text_color: '#264653',
                    },
                    {
                        name: 'Pieces Processed',
                        text_color: '#F4A261',
                    },
                    {
                        name: 'Items Processed',
                        text_color: '#E76F51',
                    },
                    {
//                        name: 'Orders on Hold',
                        name: 'Orders Hold',
                        text_color: '#E9C46A',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>